import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; 2026 Учет посещений занятий</p>
    </footer>
  );
};

export default Footer;